import React from "react";
import { Button, Col, Container, Row, TabPane } from "reactstrap";
import { Quotation } from "../../../../Quotations/components/Quotation";
import {
  FIRST_MONTH,
  LAST_MONTH,
  TODAY_NUMBER_MONTH
} from "../../../../Quotations/components/QuotationTable";
import { Filters, QuotationInterface } from "../../../../Quotations/types";
import { getEmptyFilters } from "../../../../Quotations/utils";
import { handleRequestError } from "../../../../utils/helpers";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { requoteMembershipRequest } from "../../../actions/partners";
import { Partner } from "../interfaces";

enum REFERRAL_CODE_STATE {
  VALID,
  INVALID,
  DEFAULT
}

interface Props {
  partner: Partner;
  quotations: QuotationInterface;
  history: any;
  getQuotations: (personaId, args, integrantes) => void;
  refreshPartner: () => void;
  activeTab: string;
}

interface State {
  isOpen: boolean;
  data: object;
  montoReactivacion: number;
  filters: Filters;

  membershipReactivateValidationMode: boolean;
  membershipReactivateMessages: any[];
  membershipReactivateCharges: any[];
  membershipReactivateConditions: object;
  membershipReactivateUserAmount: number;
  selectedMonths: any[];
  stateReferral: REFERRAL_CODE_STATE;
  codigoReferido: string;
}

const search = (f, id, filters, integrantes) => {
  f(
    id,
    {
      ...filters,
      mesInicio: FIRST_MONTH,
      mesFin: LAST_MONTH,
      diaInicio: TODAY_NUMBER_MONTH
    },
    integrantes
  );
};

let filters = getEmptyFilters();

//-------------COMPONENTE INTERNO PARA COTIZACION---------------------------
const Quotations = props => {
  const handleSwitch = () => {
    props.executeConditionsValidation();
  };

  const onChangeFilters = newFilters => {
    filters = newFilters;
    filters.clubAlternoId = newFilters.clubAlterno;

    if (newFilters.membresia && newFilters.club) {
      newFilters.tipoCotizacion =
        newFilters.tipoCotizacion == "RECOTIZACION"
          ? "VENTA"
          : newFilters.tipoCotizacion;
      search(
        props.getQuotations,
        props.partner.idPersona,
        {
          tipoPrecio: 1,
          clubAlternoId: newFilters.clubAlterno,
          ...newFilters,
          personaId: props.partner.idPersona
        },
        []
      );
    }

    props.setFilters(filters);
  };

  return (
    <Container className="w-100 p-0 my-3">
      <Row>
        <Col lg={12} md={12} xs={12} className="w-100 p-0 m-0 test-class">
          <Quotation
            enableMemberEdition
            onChangeFilters={onChangeFilters}
            quotation={props.quotations}
            quotationUse={props.quotationUse}
            checkMode={props.checkMode}
            updateSelectedMonths={props.updateSelectedMonths}
            partner={props.partner}
            disableReferredCode={false}
            setStateReferral={props.setStateReferral}
            setCodigoReferido={props.setCodigoReferido}
          />
        </Col>
        <hr />
        <Col className="pl-0">
          <Button
            onClick={handleSwitch}
            disabled={
              props.stateReferral == REFERRAL_CODE_STATE.INVALID ||
              !props.quotations
            }
          >
            Aplicar recotización
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
//----------------------------------------------------------------------------

class TabRequotation extends React.Component<Props, State> {
  state = {
    isOpen: false,
    data: null,
    montoReactivacion: null,
    filters: null,
    membershipReactivateValidationMode: false,
    membershipReactivateMessages: [],
    membershipReactivateCharges: [],
    membershipReactivateConditions: null,
    membershipReactivateUserAmount: null,
    selectedMonths: [],
    stateReferral: REFERRAL_CODE_STATE.DEFAULT,
    codigoReferido: null
  };

  executeMembershipRequotation = () => {
    const { filters } = this.state;
    if (!!filters.biclub && filters.biclub == "true" && !filters.clubAlterno) {
      errorNotification("Debe seleccionar un club alterno");
      return;
    }

    if (this.state.stateReferral == REFERRAL_CODE_STATE.INVALID) {
      errorNotification("El código de referido no es válido");
      return;
    }

    const body = {
      idMembresiaSocio: this.props.partner.idMembresiaSocio,
      idPersona: this.props.partner.idPersona,
      idPropietario: this.props.partner.idPropietario,
      idMembresia: filters.membresia,
      idClubBase: filters.club,
      idMantenimiento: filters.mantenimiento,
      idConvenio: filters.convenio,
      formaPagoDescuento: filters.descuento || "EFECTIVO",
      idEmpresa: filters.empresa,
      idPromocion: filters.promocion,
      idPromocionAlt: filters.promocionAlt,
      idPromocionBeneficioProducto: filters.promocionBeneficioProducto,
      fechaAdquisicion: null,
      idClubAlterno: filters.clubAlterno || null,
      precioBaseMembresia: this.props.quotations.precioMembresia,
      precioVentaMembresia: this.props.quotations.precioMembresia,
      certificado: false,
      ventaEnLinea: false,
      fechaInicioMantenimiento: filters.fechaInicioAcceso || null,
      fechaInicioAcceso: filters.fechaInicioAcceso || null,
      estatusMembresia: "ACTIVA",
      intransferible: false,
      nueva: true,
      limiteInicioMantenimiento: 1,
      idMembresiaPrecio: this.props.quotations.precioMembresiaId,
      mesesCotizacion: [
        ...this.state.selectedMonths.map(x => {
          x.integrantes.bebes = null;
          x.integrantes.extras = null;
          return x;
        })
      ],
      codigoReferido: this.state.codigoReferido,
      codigoReferidoValidacion: this.state.codigoReferido
    };

    requoteMembershipRequest(body)
      .then(({ data }) => {
        successNotification("Recotización aplicada correctamente");
        if (!!this.props.refreshPartner) {
          this.props.refreshPartner();
        }
      })
      .catch(handleRequestError);
  };

  render() {
    if (this.props.activeTab != "25") {
      return <></>;
    }

    return (
      <TabPane className="my-2" tabId="25">
        <Container className="p-0 m-0">
          <Row className="p-0 m-0">
            <Quotations
              {...this.props}
              quotationUse="RECOTIZACION"
              executeConditionsValidation={this.executeMembershipRequotation}
              setFilters={filters => {
                this.setState({ filters });
              }}
              checkMode={true}
              updateSelectedMonths={months => {
                this.setState({ selectedMonths: [...months] });
              }}
              setStateReferral={newStateReferral => {
                this.setState({ stateReferral: newStateReferral });
              }}
              setCodigoReferido={newCodigoReferido => {
                this.setState({ codigoReferido: newCodigoReferido });
              }}
              stateReferral={this.state.stateReferral}
            />
          </Row>
        </Container>
      </TabPane>
    );
  }
}
export default TabRequotation;
